exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-19a3fa1e]{background-color:#fff}.loader .loader-background-illustration[data-v-19a3fa1e]{position:absolute;right:0;left:0;width:100%;height:36px;background-position:top;background-size:cover;background-repeat:no-repeat}@media (max-width:575.98px){.loader .loader-background-illustration[data-v-19a3fa1e]{height:18px}}.loader .loader-background-illustration--top[data-v-19a3fa1e]{top:0}.loader .loader-background-illustration--bottom[data-v-19a3fa1e]{bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19a3fa1e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/App/Partials/Preloader.vue
// module id = 160
// module chunks = 35